'use client';

import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, CircleDollarSign } from "lucide-react";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";

type GuaranteeProps = {
  isBot: boolean;
};

const guaranteeContainerVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      staggerChildren: 0.2,
    },
  },
};

export default function Guarantee({ isBot }: GuaranteeProps) {
  const Wrapper = isBot ? "div" : motion.div;
  return (
    <section id="guarantee" className="py-10 sm:py-16">
      <div
        className="container mx-auto px-4"
      >
        <Wrapper 
          className="mx-auto max-w-4xl"
          initial={isBot ? undefined : "hidden"}
          whileInView={isBot ? undefined : "visible"}
          viewport={isBot ? undefined : { once: false, amount: 0.5 }}
          variants={isBot ? undefined : guaranteeContainerVariants}
        >
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            <motion.div variants={isBot ? undefined : guaranteeContainerVariants}>
              <Card className={cn("p-8 text-center bg-secondary border-border h-full", "message-bubble")}>
                <ShieldCheck className="mx-auto h-12 w-12 text-primary" />
                <h3 className="mt-4 font-headline text-2xl tracking-tight font-semibold">
                  Teste Grátis por 30 Dias
                </h3>
                <p className="mt-2 text-foreground/90 tracking-tight">
                  Disponível para o plano <strong>Médico Solo</strong>. Explore todos os recursos sem compromisso e veja o impacto na sua rotina.
                </p>
              </Card>
            </motion.div>
            <motion.div variants={isBot ? undefined : guaranteeContainerVariants}>
              <Card className={cn("p-8 text-center bg-secondary border-border h-full", "message-bubble-right")}>
                <CircleDollarSign className="mx-auto h-12 w-12 text-primary" />
                <h3 className="mt-4 font-headline text-2xl tracking-tight font-semibold">
                  Garantia Médico-Testada
                </h3>
                <p className="mt-2 text-foreground/90 tracking-tight">
                  Para planos superiores, oferecemos <strong>30 dias de garantia incondicional</strong>. Se não ficar satisfeito, devolvemos 100% do seu investimento. Risco zero.
                </p>
              </Card>
            </motion.div>
          </div>
        </Wrapper>
      </div>
    </section>
  );
}
